import { render, staticRenderFns } from "./ClientSeeds.vue?vue&type=template&id=e4585080&"
import script from "./ClientSeeds.vue?vue&type=script&lang=js&"
export * from "./ClientSeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports